import { Injectable } from '@angular/core';
import { ConfigService } from './config.service';
import { EventEmitter } from '@angular/core';

@Injectable()
export class LogService {
	public static alertCreate: EventEmitter<string> = new EventEmitter();

	// errors should be in this JSON format
	/*
	{
			type: str, [ error , warning , success , info ]
			title : str
			body: str
	}
	*/
	static emitAlert(format : any) {
		LogService.alertCreate.emit(format);
	}

    constructor(protected configService:ConfigService) {
        // You can do a check on your environment or some other flag to 
        // enable/disable logging
		// if ((<any>'<%= ENV %>') === 'prod') this.enabled = false;
	}
	private enabled:boolean = this.configService.getConsole();
	private noop = () => {};



	get debug() {
		if (this.enabled) return console.debug.bind(console);
		return this.noop;
	}

	get error() {
		if (this.enabled) return console.error.bind(console);
		return this.noop;
	}

	get log() {
		if (this.enabled) return console.log.bind(console);
		return this.noop;
	}

	get info() {
		if (this.enabled) return console.info.bind(console);
		return this.noop;
	}

	get warn() {
		if (this.enabled) return console.warn.bind(console);
		return this.noop;
	}

}